import React from "react";
import style from "./Footer.module.css"

export default function Footer() {
  return (
    <>
      <div className={`${style.footer} py-2 text-center`}>
        <h5 className="mb-0 h6">Developed By OMAR GAMAL Al-DEN</h5>
      </div>
    </>
  );
}
